import { Component, ContentChild, HostBinding, ViewEncapsulation } from '@angular/core';
import { CaFormFieldControl as _CaFormFieldControl } from './form-field-control';

/**
 * This has been stolen from MatFormFieldControl
 */
interface CaFormFieldControl<T> extends _CaFormFieldControl<T> {}
@Component({
  selector: 'ca-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CaFormFieldComponent {
  @ContentChild(_CaFormFieldControl)
  control!: CaFormFieldControl<any>;

  @HostBinding('class.error') get hasError() {
    return (
      this.control?.ngControl?.dirty &&
      this.control?.ngControl?.touched &&
      this.control?.ngControl?.invalid
    );
  }

  @HostBinding('class.disabled') get isDisabled() {
    return this.control?.ngControl?.disabled;
  }

  get error() {
    const errors = Object.entries(this.control?.ngControl?.control.errors ?? {});
    if (!this.control?.ngControl?.dirty && !this.control?.ngControl?.touched) {
      return '';
    }
    if (!errors.length) {
      return null;
    }
    return errors[0][0];
  }
}
